import type { FirebaseConfigType } from './type';

export const FirebaseConfig: FirebaseConfigType = {
  apiKey: 'AIzaSyCHklXdvZbJUOubsILq2TZD6Kvw8-X06Aw',
  authDomain: location.hostname === 'admin.balus.app' ? 'admin.balus.app' : 'balus.app',
  databaseURL: 'https://levii-balus-app-default-rtdb.firebaseio.com',
  projectId: 'levii-balus-app',
  storageBucket: 'levii-balus-app.appspot.com',
  messagingSenderId: '638286101593',
  appId: '1:638286101593:web:39be1f82df62a15ac80548',
  measurementId: 'G-PF947JTP4Z',
  actionLogDatabaseURL: 'https://levii-balus-app-action-log-rtdb.firebaseio.com',
};
